export default {
  isAuthenticated : (auth) => auth.token !== null,
  isFirstAccess   : (auth) => auth.lastAccess === null,
  isRoleOperation : (auth, getters, rootState) => {
    if (auth.currentRole && auth.currentRole.tenant) {
      return !auth.currentRole.tenant.alias;
    }

    return rootState._core.application.isOperation;
  },
  isImpersonated   : (auth) => auth.impersonatedBy !== null,
  hasCurrentRole   : (auth) => auth.currentRole !== null,
  hasRights        : (auth) => auth.tenantsRights?.length > 0 || auth.applicationsRoles?.roles?.length > 0,
  hasOnlyOneRights : (auth) => {
    const tenantsRights = auth.tenantsRights;
    const onlyOneTenantRights = tenantsRights.length === 1;
    if (onlyOneTenantRights) {
      if (tenantsRights[0].roles.length > 1) {
        return false;
      }

      const noRolesOnTenantRights = tenantsRights[0].roles.length === 0;
      const onlyOneIesRoleTenantRights = tenantsRights[0].ies.length === 1 && tenantsRights[0].ies[0].roles.length === 1;
      if (noRolesOnTenantRights) {
        if (onlyOneIesRoleTenantRights) {
          return true;
        }
      } else {
        const hasRolesOnIes = tenantsRights[0].ies.length > 0;
        if (!hasRolesOnIes) {
          return true;
        }
      }
    }

    return false;
  },
  getFirstRights: (auth) => {
    const { applicationsRoles, tenantsRights, lastAccess } = auth;

    if (!lastAccess?.tenantId && !lastAccess?.iesId) {
      if (applicationsRoles?.roles?.length > 0) {
        return {
          tenant : null,
          ies    : null,
          role   : applicationsRoles.roles[0]
        };
      }
    }

    if (tenantsRights?.length > 0) {
      if (tenantsRights[0].roles.length >= 1) {
        return {
          tenant : tenantsRights[0],
          ies    : null,
          role   : tenantsRights[0].roles[0]
        };
      } else if (tenantsRights[0].ies.length >= 1) {
        return {
          tenant : tenantsRights[0],
          ies    : tenantsRights[0].ies[0],
          role   : tenantsRights[0].ies[0].roles[0]
        };
      }
    }

    return null;
  },
  getCurrentRoleHostname: (auth, getters, rootState) => {
    let urlPath = rootState.hostname;

    if (auth.currentRole) {
      if (auth.currentRole.ies?.hostname) {
        urlPath = auth.currentRole.ies?.hostname;
      } else if (auth.currentRole.tenant?.hostname) {
        urlPath = auth.currentRole.tenant.hostname;
      }
    }

    if ((/^http?:\/\//i).test(urlPath) || (/^https?:\/\//i).test(urlPath)) {
      return `${urlPath}${process.env.APPLICATION_ROUTE_BASE}`;
    }

    return `https://${urlPath}${process.env.APPLICATION_ROUTE_BASE}`;
  },
  getWebComponentToken: (auth) => (entryPoint) => {
    const webComponent = auth.webComponents[entryPoint];

    if (webComponent) {
      return webComponent.token;
    }

    return null;
  }
};
